<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import user_detection from "./mixins/user_detection";

export default {
  mixins: [user_detection],
  name: "App",
  data() {
    return {};
  },
  mounted() {
    this.isUserAdmin();
  },
  computed: {},
  methods: {},
  components: {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/App.vue